import { render, staticRenderFns } from "./CatalogListProperties.vue?vue&type=template&id=34ea38f5"
import script from "./CatalogListProperties.vue?vue&type=script&lang=js"
export * from "./CatalogListProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports